<aside class="bg-black min-vh-100">
  <nav class="p-3">
    <div class="text-uppercase text-white-50 small fw-semibold mb-2">
    </div>

    <div class="list-group list-group-flush">
      @for (item of menu; track item.id) {
        <ng-container
          [ngTemplateOutlet]="navItemTpl"
          [ngTemplateOutletContext]="{ item: item, level: 0 }">
        </ng-container>
      }
    </div>
  </nav>

  <!-- Recursive template -->
  <ng-template #navItemTpl let-item="item" let-level="level">

    <!-- Leaf -->
    @if (item.route && !item.children?.length) {
      <a
        class="list-group-item list-group-item-action d-flex align-items-center gap-2 bg-black text-white border-0"
        [style.paddingLeft.px]="16 + level * 16"
        [routerLink]="item.route"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">

        @if (item.icon) {
            <i class="bi {{ item.icon }}"></i>
        }
        <span>{{ item.label }}</span>
      </a>
    }

    <!-- Group -->
    @if (item.children?.length) {
      <button
        type="button"
        class="list-group-item list-group-item-action d-flex align-items-center justify-content-between bg-black text-white border-0"
        [style.paddingLeft.px]="16 + level * 16"
        (click)="toggle(item.id)">

        <span class="d-flex align-items-center gap-2">
        @if (item.icon) {
            <i class="bi {{ item.icon }}"></i>
        }
          <span>{{ item.label }}</span>
        </span>

        <span class="text-white-50 small">
          {{ isOpen(item.id) ? '▾' : '▸' }}
        </span>
      </button>

      <div [ngbCollapse]="!isOpen(item.id)">
        @for (child of item.children; track child.id) {
          <ng-container
            [ngTemplateOutlet]="navItemTpl"
            [ngTemplateOutletContext]="{ item: child, level: level + 1 }">
          </ng-container>
        }
      </div>
    }

  </ng-template>
</aside>
